export const Atted = (arg: string): string => {
  return !arg ? "@" : arg;
}

export const DeAtted = (arg: string): string => {
  return arg === "@" ? "" : arg;
}

export const isIOS = (): boolean => {
  const msStream: unknown = (window as Window & { MSStream?: unknown }).MSStream;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !msStream;
};